import { getValue } from '../../../../util';
import {
  getDataFromServer,
  getInvestigationResult,
  getInDecimal
} from '../../../util';
import { convertISOToDateFormat } from '../../../../util/timezone';
import { normalizeAlertScore } from '../../../../util/normalization';
import { keys, map, parseInt } from 'lodash';
import { FRAUD_PREVENTION_SOURCE_IDS } from '../../../../pages/constants/commonConstants';

const SOURCE_IDS = '0,1,2,4,5,6,10,11,12,13,14,15,18,19,21,22,23,26,25,29';

export class AlertHistoryModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchAlertHistory = async (payload) => {
    const { customerKey, to, from, offset, limit, isScrolled } = payload;

    const url = `${this.baseURL}/alerts`;
    const params = {
      to,
      from,
      limit: limit || 10,
      offset: offset || 0,
      customerId: `${customerKey},`,
      sourceIds: SOURCE_IDS
    };

    const data = await getDataFromServer(url, this.httpHeaders, params);
    const listOfAlerts = data?.payload?.map((o) => {
      const {
        alertId,
        alertSourceId,
        alertDate,
        primaryPartyKey,
        primaryPartyName,
        isIssue,
        alertStatus,
        triggeredRules,
        triggeredTypologies,
        alertLevel,
        alertLevelLabel,
        alertLevelColor,
        alertScore,
        segmentName,
        segmentCode,
        accountId,
        accountType,
        accountOpenDate,
        hitsScore,
        alertAge,
        clusterId,
        clusterScore,
        analystName,
        closureDate,
        investigationResult,
        modelId,
        isStaff,
        isStr,
        alertSourceName,
        additionalFraudInfo,
        fraudActions
      } = o;

      let rules = map(triggeredTypologies, 'name')?.join(', ');
      let level = getValue(alertLevelLabel || alertLevel);
      let levelDowload = level;

      if (FRAUD_PREVENTION_SOURCE_IDS.includes(parseInt(alertSourceId))) {
        rules = map(triggeredRules, 'ruleName')?.join(', ');
        levelDowload = keys(additionalFraudInfo)
          ?.map((key) => `${key}: ${additionalFraudInfo[key]}`)
          ?.join(', ');
      }

      return {
        closureDate: closureDate ? convertISOToDateFormat(closureDate) : '',
        str: getValue(isStr),
        isIssue: getValue(isIssue),
        investigationResult: getInvestigationResult(
          alertStatus,
          isStr,
          isIssue,
          investigationResult
        ),
        accountId: getValue(accountId),
        isPrimaryOwner: false,
        alertDate: alertDate ? convertISOToDateFormat(alertDate) : '',
        isScrolled,
        primaryPartyKey,
        primaryPartyName,
        alertType: alertSourceName,
        alertStatus,
        alertLevel: level,
        alertLevelColor,
        levelDowload,
        alertScore: getInDecimal(normalizeAlertScore(alertScore)),
        // Fix for MIC-2851
        detailedAlertScore: normalizeAlertScore(alertScore),
        segmentName: getValue(segmentName),
        segmentCode,
        accountType,
        accountOpenDate,
        hitsScore,
        alertAge,
        clusterId,
        clusterScore,
        analystName,
        accountCurrency: 'SGD', //fix this,
        isStr: isStr ? 'TRUE' : 'FALSE',
        modelId,
        isStaff,
        alertId,
        rules,
        alertSourceId,
        additionalFraudInfo,
        fraudActions
      };
    });
    return {
      alert_list: listOfAlerts,
      count: data?.total ? data.total : 0,
      isScrolled
    };
  };
}
